export class FileListElement {
  constructor(fileListId, inputName) {
    this.fileList = document.getElementById(fileListId);
    this.inputName = inputName;
    this.init();
  }

  init() {
    // Инициализация кнопок удаления
    this.fileList.querySelectorAll('.delete-file').forEach((button) => {
      button.addEventListener('click', (event) => this.removeFile(event));
    });
  }

  removeFile(event) {
    const button = event.target.closest('.delete-file');
    const fileId = button.dataset.fileId;
    const fileItem = this.fileList.querySelector('.file-item[data-file-id="' + fileId + '"]');

    if (fileItem) {
      // Удаление элемента из DOM
      // Создание скрытого input для передачи удаленного файла
      // if (this.inputName) console.log('удаление в FileList включено');
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'files[delfile]';
      hiddenInput.value = fileId;

      // Добавление скрытого input в контейнер списка файлов
      this.fileList.appendChild(hiddenInput);

      fileItem.remove();
    }

    this.fileList.closest('fieldset').updateData()
  }
}
